// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";
import GradientHeader from "src/components/shared/displays/GradientHeader/GradientHeader";
import PatientPage from "./PatientPage/PatientPage";
import DashboardPage from "./DashboardPage/DashboardPage";
import LiveUpdatePage from "./LiveUpdatePage/LiveUpdatePage";

type PortalOverviewType = {
  title: string;
};

const PortalOverview = ({ title }: PortalOverviewType) => {
  const { t } = useTranslation("operating-manual");

  return (
    <OperatingManualContent title={title}>
      <Box
        id="patient-page"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`5.1 ${t("Patient Page")}`} />
        <Box sx={{ mx: "20px" }}>
          <PatientPage />
        </Box>
      </Box>

      <Box
        id="dashboard-page"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`5.2 ${t("Dashboard Page")}`} />
        <Box sx={{ mx: "20px" }}>
          <DashboardPage />
        </Box>
      </Box>

      <Box
        id="live-update-page"
        sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <GradientHeader header={`5.3 ${t("Live Update Page")}`} />
        <Box sx={{ mx: "20px" }}>
          <LiveUpdatePage />
        </Box>
      </Box>
    </OperatingManualContent>
  );
};

export default PortalOverview;
